import useTranslation from "utils/hooks/useTranslation";
import CustomSelector from "../CustomSelector";
import { useCallback } from "react";
import Input, { InputType } from "components/shared/inputs/input";
import { convertToSelect } from "utils";
import { habitatLevel, habitatOwnership, installationWallTypes, insulationCeilingTypes, insulationFloorOnTypes, insulationFloorTypes, insulationOpeningDoorClass, insulationOpeningMat, insulationOpeningTypes, insulationVentilationTypes, atticTypes, houseTypes } from "constants/dropdown";
import HeatModeZone from "./HeatModeZone";
import { useAppSelector } from "store/hooks";
import { useSelector } from "react-redux";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import _ from "lodash";
import { SvgInfo, SvgInfoOutline, SvgLShaped, SvgRectangle, SvgSquare } from "components/svg";
import Tooltip from "antd/lib/tooltip";

type HeatModeExpertMethodProps = {
    control: any
    errors: any
    deperditions: any
    calculateDeperd: () => void
    watch: any
    getFieldState: any
    setValue: any
    addZone: () => void
    removeZone: (index: number) => void
    onSelect: any
    getValues: any
    setDisableNavigarion: (val: boolean) => void
    trigger: any
    calculateDeperdAndFlowTemperature?: () => void
}

const habitatFormes = [
    {
        code: "1",
        label: 'HABITAT_FORME_RECT',
        icon: <SvgRectangle />,
    },
    {
        code: "0",
        label: 'HABITAT_FORME_CARRE',
        icon: <SvgSquare />,
    },
    {
        code: "2",
        label: 'HABITAT_FORME_L',
        icon: <SvgLShaped />,
    },
]

const HeatModeExpertMethod: React.FC<HeatModeExpertMethodProps> = (props) => {
    const { t, tHtml } = useTranslation()
    const { network, isThermor } = useSalesNetwork()
    const projectStore = useSelector((state: any) => state.project)
    const { setValue, addZone, removeZone, onSelect, calculateDeperd, getValues, setDisableNavigarion, calculateDeperdAndFlowTemperature, trigger } = props;
    const [zones, levels] = props.watch(['heatMode.zones', 'heatMode.deperditions.levels', 'heatMode.deperditions.levels_motor']) || [];

    const onHomeTypeChange = useCallback((code: string) => {
        props.setValue('heatMode.deperditions.houseShape', code, { shouldValidate: true, shouldDirty: true })
    }, [])


    const getInputLabel = useCallback((label: string, isRequired: boolean = true) => {
        return (
            <group data-max-length="250">
                <label className="form_fields">
                    <div className="data_label">
                        <text data-wrap="wrap">{t(label)}{isRequired && <i data-space-horizontal="5" data-color="red">*</i>}</text>
                    </div>
                </label>
            </group>
        )
    }, [t]);

    const onLevelsChange = useCallback((e: any) => {
        props.setValue('heatMode.deperditions.levels', e, { shouldValidate: true, shouldDirty: true })
        props.setValue('heatMode.deperditions.levels_motor', e)
        props.setValue('heatMode.deperditions.homeAttics', false)
    }, [props])

    const onHomeAtticsChange = useCallback((e: any) => {
        props.setValue('heatMode.deperditions.homeAttics', e.target.checked, { shouldValidate: true, shouldDirty: true })
        if (e.target.checked) {
            props.setValue('heatMode.deperditions.levels_motor', +levels + 0.5)
        } else {
            props.setValue('heatMode.deperditions.levels_motor', levels - 0.5)
        }
    }, [levels, props])

    const handleCalculate = useCallback(async () => {
        // call calculation if provided
        try {
            if (calculateDeperdAndFlowTemperature) await calculateDeperdAndFlowTemperature();
        } catch (e) {
            // ignore calculation errors here
        }

        // trigger validation if available
        try {
            if (trigger) await trigger();
        } catch (e) {
            // ignore
        }

        // find the first invalid field and scroll it into view (only on actual errors, not required fields)
        try {
            const selectors = '.is-invalid, [aria-invalid="true"], .error, .invalid, [data-invalid="true"], :invalid';
            const el: Element | null = document.querySelector(selectors);
            if (el) {
                const elHtml = el as HTMLElement;
                if (typeof elHtml.scrollIntoView === 'function') {
                    elHtml.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                try { (elHtml as HTMLElement).focus(); } catch (e) { }
            }
        } catch (e) {
            // ignore DOM errors
        }
    }, [calculateDeperdAndFlowTemperature, trigger]);

    const HelpTooltip = useCallback(({ content }: { content: string }) => {
        return (
            <group data-width="auto">
                <Tooltip
                    arrow={false}
                    //color="var(--accent-dark)"
                    color="var(--white)"
                    //space={false}
                    title={
                        <group data-direction="column" data-gap="10" data-space="10" data-max-length="600">
                            <text data-color="black" data-line="1.5">
                                {tHtml(content)}
                            </text>
                        </group>
                    }
                >
                    {isThermor ?
                        <icon data-svg-size="24" data-svg-color="secondary-light" data-cursor="pointer"><SvgInfoOutline /></icon>
                        :
                        <icon data-svg-size="24" data-svg-color="secondary" data-cursor="pointer"><SvgInfo /></icon>}
                </Tooltip>
            </group>
        )
    }, [])

    const InputWithUnknown = useCallback((name: string, label: string) => {
        const value = props.watch(`heatMode.deperditions.${name}Unknown`);
        const twoDecimalFields = [
            'wallCoefficient',
            'wallInsulationR',
            'ceilingCoefficient',
            'ceilingInsulationR',
            'floorCoefficient',
            'floorInsulationR',
            'windowCoefficient',
            'doorCoefficient',
        ];
        const useTwoDecimals = twoDecimalFields.includes(name);

        return (<>
            <group data-direction="column" data-gap="5">
                {getInputLabel(label)}
                <group data-direction="row" data-gap="20" >
                    <group data-max-length="250">
                        <Input
                            type={InputType.Number}
                            control={props.control}
                            name={`heatMode.deperditions.${name}`}
                            allowSearch={true}
                            size="large"
                            translateValue={true}
                            {...(useTwoDecimals ? { step: 1, precision: 2 } : {})}
                            disabled={value}
                        />
                    </group>
                    <group data-max-length="250">
                        <Input
                            type={InputType.Checkbox}
                            label={t('UNKNOWN')}
                            requiredLabel={true}
                            control={props.control}
                            name={`heatMode.deperditions.${name}Unknown`}
                            onChange={(e: any) => {
                                props.setValue(`heatMode.deperditions.${name}Unknown`, e.target.checked, { shouldValidate: true, shouldDirty: true })
                                if (e.target.checked) {
                                    props.setValue(`heatMode.deperditions.${name}`, null, { shouldValidate: true })
                                }
                            }}
                        />
                    </group>
                </group >
            </group>
        </>)
    }, [props.control, props.watch, t, getInputLabel])

    return <>
        <group data-gap="5" data-space="10" data-space-left='0'>
            <group data-align="center" data-width="auto" data-gap="10">
                <text data-weight="600" data-text-size="large" data-ellipsis="" data-color="grey-color-dark">
                    {t('HABITAT_DESC')}
                </text>
            </group>
            <group data-gap="10" data-space="10" data-space-left="0" data-radius="10" data-direction="column">
                <group data-width="auto" data-direction="column" data-justify="end" data-gap="10">
                    <Input
                        type={InputType.Select}
                        label={'HOUSE_TYPE'}
                        requiredLabel={true}
                        control={props.control}
                        options={houseTypes}
                        name={`heatMode.deperditions.houseType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                        defaultValue={houseTypes[0].value}
                    />
                    <group data-gap="10" data-align="center" data-name="custom_option">
                        <group >
                            <text data-text-size="medium" data-color="grey-color-dark">{t("HABITAT_FORME_MAISON")}<i data-space-horizontal="5" data-color="red">*</i></text>
                        </group>
                        <CustomSelector
                            itemLength="180"
                            name="heatMode.deperditions.houseShape"
                            control={props.control}
                            items={habitatFormes}
                            selected={props.deperditions?.houseShape}
                            onChange={onHomeTypeChange}
                        />
                    </group>
                    <group data-gap="20">
                        <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                            <Input
                                type={InputType.Select}
                                label={'HABITAT_LEVEL'}
                                requiredLabel={true}
                                control={props.control}
                                options={convertToSelect(habitatLevel)}
                                name={`heatMode.deperditions.levels`}
                                allowSearch={true}
                                size="large"
                                translateValue={true}
                                onChange={(e: any) => onLevelsChange(e)}
                            />
                        </group>

                        <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                            <Input
                                type={InputType.Select}
                                label={'HABITAT_OWNERSHIP'}
                                requiredLabel={true}
                                control={props.control}
                                options={convertToSelect(habitatOwnership)}
                                name={`heatMode.deperditions.adjacency`}
                                allowSearch={true}
                                size="large"
                                translateValue={true}
                            />
                        </group>
                    </group>
                    <group data-direction="column">
                        <group data-direction="column" data-max-length="225">
                            <Input
                                type={InputType.Checkbox}
                                label={t('HABITAT_ATTICS')}
                                control={props.control}
                                name={`heatMode.deperditions.homeAttics`}
                                onChange={(e: any) => onHomeAtticsChange(e)}
                            />
                        </group>
                        {/* <group data-direction="column" data-max-length="225">
                            <Input
                                type={InputType.Checkbox}
                                label={t('HABITAT_ISOLATION')}
                                control={props.control}
                                name={`heatMode.deperditions.homeIsolation`}
                            />
                        </group> */}
                    </group>
                </group>
                <group data-length="autofit" data-gap="20">
                    <group data-gap="10" data-radius="10" data-direction="column">
                        <group data-align="center" data-width="auto" data-gap="10">
                            <text data-weight="600" data-text-size="large" data-ellipsis="" data-color="grey-color-dark">
                                {t('HABITAT_DESCRIPTION')}
                            </text>
                            {<group data-width="auto">
                                <Tooltip
                                    arrow={false}
                                    //color="var(--accent-dark)"
                                    color="var(--white)"
                                    //space={false}
                                    title={
                                        <group data-direction="column" data-gap="10" data-space="10" data-max-length="300">
                                            <text data-color="black" data-line="1.5">
                                                {tHtml('HELP_DESC_HABITAT')}
                                            </text>
                                        </group>
                                    }
                                >
                                    {isThermor ?
                                        <icon data-svg-size="24" data-svg-color="secondary-light" data-cursor="pointer"><SvgInfoOutline /></icon>
                                        :
                                        <icon data-svg-size="24" data-svg-color="secondary" data-cursor="pointer"><SvgInfo /></icon>}
                                </Tooltip>
                            </group>}
                        </group>

                        {zones?.map((zone: any, index: any) => (
                            <HeatModeZone
                                key={index}
                                name={`zones[${index}]`}
                                control={props.control}
                                index={index}
                                zone={zone}
                                setValue={setValue}
                                addZone={addZone}
                                removeZone={removeZone}
                                calculateDeperd={calculateDeperd}
                                onSelect={onSelect}
                                getValues={getValues}
                                setDisableNavigarion={setDisableNavigarion}
                                autoCalc={false}
                            />
                        ))}
                    </group>
                </group>
                <group data-direction="column" data-gap="20">
                    <group data-fit="1" data-border="1" data-border-color="main-color-lighter" >
                    </group>
                    <group data-align="center" data-width="auto" data-gap="10">
                        <text data-text-size="large" data-ellipsis="" data-color="main">
                            {t('INSULATION_WALL')}
                        </text>
                        {<HelpTooltip content={'HELP_WALL_TOOLTIP'} />}
                    </group>
                </group>
                <group data-gap="20">
                    <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                        <Input
                            // data-width="auto"
                            type={InputType.Select}
                            label={'INSULATION_WALL_TYPE'}
                            requiredLabel={true}
                            control={props.control}
                            options={convertToSelect(installationWallTypes)}
                            name={`heatMode.deperditions.wallType`}
                            allowSearch={true}
                            size="large"
                            translateValue={true}
                        />
                    </group>

                    <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                    </group>
                </group>

                {InputWithUnknown('wallSurface', 'INSULATION_WALL_SURFACE')}
                {InputWithUnknown('wallCoefficient', 'INSULATION_WALL_COEFF')}
                {InputWithUnknown('wallThickness', 'INSULATION_WALL_THICKNESS')}
                <group>
                    <group data-max-length="200" data-align="bottom">
                        <Input
                            type={InputType.Checkbox}
                            label={t('INSULATION_WALL_ISOLATED')}
                            requiredLabel={true}
                            control={props.control}
                            defaultChecked={true}
                            name={`heatMode.deperditions.wallIsolated`}
                            onChange={(e) => {
                                props.setValue(`heatMode.deperditions.wallIsolated`, e.target.checked, { shouldValidate: true, shouldDirty: true })
                                if (!e.target.checked) {
                                    props.setValue(`heatMode.deperditions.wallInsulationR`, null, { shouldValidate: true })
                                    props.setValue(`heatMode.deperditions.wallInsulationThickness`, null, { shouldValidate: true })
                                } else {
                                    props.setValue(`heatMode.deperditions.wallInsulationR`, null, { shouldDirty: true })
                                    props.setValue(`heatMode.deperditions.wallInsulationRUnknown`, true, { shouldValidate: true, shouldDirty: true })
                                }
                            }}
                        />
                    </group>
                </group>
                {props.watch('heatMode.deperditions.wallIsolated') && InputWithUnknown('wallInsulationR', 'INSULATION_WALL_INSULATION_R')}
                {props.watch('heatMode.deperditions.wallIsolated') && InputWithUnknown('wallInsulationThickness', 'INSULATION_WALL_IINSULATION_THICKNESS')}
            </group>
            <group data-direction="column" data-gap="20">
                <group data-fit="1" data-border="1" data-border-color="main-color-lighter" >
                </group>
                <group data-align="center" data-width="auto" data-gap="10">
                    <text data-text-size="large" data-ellipsis="" data-color="main">
                        {t('INSULATION_CEILING')}
                    </text>
                    {<HelpTooltip content={'HELP_CEILING_TOOLTIP'} />}
                </group>
            </group>

            <group data-gap="20">
                <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">

                    <Input
                        type={InputType.Select}
                        label={'INSULATION_CEILING_TYPE'}
                        requiredLabel={true}
                        control={props.control}
                        options={convertToSelect(insulationCeilingTypes)}
                        name={`heatMode.deperditions.ceilingType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>

                <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_CEILING_ATTIC'}
                        requiredLabel={true}
                        control={props.control}
                        options={convertToSelect(atticTypes)}
                        name={`heatMode.deperditions.atticType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>
            </group>
            {InputWithUnknown('roofSurface', 'INSULATION_CEILING_SURFACE')}
            {InputWithUnknown('ceilingCoefficient', 'INSULATION_CEILING_COEFF')}
            <group>
                <group data-max-length="300" data-align="bottom">
                    <Input
                        type={InputType.Checkbox}
                        label={t('INSULATION_CEILING_ISOLATED')}
                        requiredLabel={true}
                        control={props.control}
                        defaultChecked={true}
                        name={`heatMode.deperditions.ceilingIsolated`}
                        onChange={(e) => {
                            props.setValue(`heatMode.deperditions.ceilingIsolated`, e.target.checked, { shouldValidate: true, shouldDirty: true })
                            if (!e.target.checked) {
                                props.setValue(`heatMode.deperditions.ceilingInsulationR`, null, { shouldValidate: true })
                                props.setValue(`heatMode.deperditions.ceilingInsulationThickness`, null, { shouldValidate: true })
                            } else {
                                props.setValue(`heatMode.deperditions.ceilingInsulationR`, null, { shouldDirty: true })
                                props.setValue(`heatMode.deperditions.ceilingInsulationRUnknown`, true, { shouldValidate: true, shouldDirty: true })
                            }
                        }}
                    />
                </group>
            </group>
            {props.watch('heatMode.deperditions.ceilingIsolated') && InputWithUnknown('ceilingInsulationR', 'INSULATION_CEILING_INSULATION_R')}
            {props.watch('heatMode.deperditions.ceilingIsolated') && InputWithUnknown('ceilingInsulationThickness', 'INSULATION_CEILING_THICKNESS')}

            <group data-direction="column" data-gap="20">
                <group data-fit="1" data-border="1" data-border-color="main-color-lighter" >
                </group>
                <group data-align="center" data-width="auto" data-gap="10">
                    <text data-text-size="large" data-ellipsis="" data-color="main">
                        {t('INSULATION_FLOOR')}
                    </text>
                    {<HelpTooltip content={'HELP_FLOOR_TOOLTIP'} />}
                </group>
            </group>
            <group data-direction="row" data-gap="20">
                <group data-fit="1" data-direction="column" data-size="large" >
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_FLOOR_TYPE'}
                        requiredLabel={true}
                        control={props.control}
                        options={convertToSelect(insulationFloorTypes)}
                        name={`heatMode.deperditions.floorType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>
                <group data-fit="1" data-direction="column" data-size="large" >
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_FLOOR_ON'}
                        requiredLabel={true}
                        control={props.control}
                        options={convertToSelect(insulationFloorOnTypes)}
                        name={`heatMode.deperditions.foundationType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>
            </group>
            {InputWithUnknown('floorSurface', 'INSULATION_FLOOR_SURFACE')}
            {InputWithUnknown('floorCoefficient', 'INSULATION_FLOOR_COEFF')}
            <group data-max-length="250">
                <Input
                    type={InputType.Checkbox}
                    label={t('INSULATION_FLOOR_ISOLATED')}
                    requiredLabel={true}
                    control={props.control}
                    name={`heatMode.deperditions.floorIsolated`}
                    onChange={(e) => {
                        props.setValue(`heatMode.deperditions.floorIsolated`, e.target.checked, { shouldValidate: true, shouldDirty: true })
                        if (!e.target.checked) {
                            props.setValue(`heatMode.deperditions.floorInsulationR`, null, { shouldValidate: true })
                            props.setValue(`heatMode.deperditions.floorInsulationThickness`, null, { shouldValidate: true })
                        } else {
                            props.setValue(`heatMode.deperditions.floorInsulationR`, null, { shouldDirty: true })
                            props.setValue(`heatMode.deperditions.floorInsulationRUnknown`, true, { shouldValidate: true, shouldDirty: true })
                        }
                    }}
                />
            </group>
            {props.watch('heatMode.deperditions.floorIsolated') && InputWithUnknown('floorInsulationR', 'INSULATION_FLOOR_INSULATION_R')}
            {props.watch('heatMode.deperditions.floorIsolated') && InputWithUnknown('floorInsulationThickness', 'INSULATION_FLOOR_THICKNESS')}
            <group data-direction="column" data-gap="20">
                <group data-space-top="20">
                    <group data-fit="1" data-border="1" data-border-color="main-color-lighter" >
                    </group>
                </group>
                <group data-align="center" data-width="auto" data-gap="10">
                    <text data-text-size="large" data-ellipsis="" data-color="main">
                        {t('INSULATION_OPENING')}
                    </text>
                    {<HelpTooltip content={'HELP_OPENING_TOOLTIP'} />}
                </group>
            </group>
            <group data-direction="row" data-gap="20">
                <group data-fit="1" data-direction="column" data-size="large" >
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_OPENING_TYPE'}
                        requiredLabel={true}
                        control={props.control}
                        options={insulationOpeningTypes}
                        name={`heatMode.deperditions.windowType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>
                <group data-fit="1" data-direction="column" data-size="large" >
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_OPENING_MAT'}
                        requiredLabel={true}
                        control={props.control}
                        options={insulationOpeningMat}
                        name={`heatMode.deperditions.windowMaterial`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>
            </group>
            {InputWithUnknown('windowSurface', 'INSULATION_OPENING_WINDOW_SURFACE')}
            {InputWithUnknown('windowCoefficient', 'INSULATION_OPENING_WINDOW_COEFF')}
            <group data-direction="row" data-gap="20">
                <group data-fit="1" data-direction="column" data-size="large" data-max-length="300" >
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_OPENING_DOOR_CLASS'}
                        requiredLabel={true}
                        control={props.control}
                        options={insulationOpeningDoorClass}
                        name={`heatMode.deperditions.doorUValue`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}

                    />
                </group>

                <group data-fit="1" data-max-length="200">
                    <Input
                        type={InputType.Number}
                        label={'INSULATION_OPENING_DOOR_WIDTH'}
                        control={props.control}
                        name={`heatMode.deperditions.openingDoorWidth`}
                        allowSearch={true}
                        size="large"
                        step={(props.deperditions.openingDoorWidth === null || props.deperditions.openingDoorWidth === undefined) ? 90 : 100}
                        translateValue={true}
                    />
                </group>
                <group data-fit="1" data-max-length="200">
                    <Input
                        type={InputType.Number}
                        label={'INSULATION_OPENING_DOOR_HEIGHT'}
                        control={props.control}
                        name={`heatMode.deperditions.openingDoorHeight`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                        step={(props.deperditions.openingDoorHeight === null || props.deperditions.openingDoorHeight === undefined) ? 215 : 100}
                    />
                </group>
            </group>
            {InputWithUnknown('doorCoefficient', 'INSULATION_OPENING_DOOR_COEFF')}
            <group data-direction="column" data-gap="20" data-space-top="20">
                <group data-fit="1" data-border="1" data-border-color="main-color-lighter" >
                </group>
                <group data-align="center" data-width="auto" data-gap="10">
                    <text data-text-size="large" data-ellipsis="" data-color="main">
                        {t('INSULATION_VENTILATION')}
                    </text>
                    {<HelpTooltip content={'HELP_VENTILATION_TOOLTIP'} />}
                </group>
            </group>
            <group data-gap="20">
                <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                        type={InputType.Select}
                        label={'INSULATION_VENTILATION_TYPE'}
                        control={props.control}
                        options={insulationVentilationTypes}
                        name={`heatMode.deperditions.ventilationType`}
                        allowSearch={true}
                        size="large"
                        translateValue={true}
                    />
                </group>

                <group data-length="forcefit" data-fit="1" data-direction="column" data-size="large">
                </group>
            </group>
            {!projectStore.project.deperds?.Study?.StudyDeperdition && <group
                data-space-vertical="20"
                data-align="center"
                data-gap="20"
                data-wrap="no"
            >
                <div className="button large secondary" onClick={handleCalculate} >
                    <text data-width="auto">{t("DEPERD_CALC_BUTTON")}</text>
                </div>
            </group>}

        </group >
    </>
}


export default HeatModeExpertMethod;